import { AutoComplete } from "./AutoComplete";
import { CheckBox } from "./Checkbox";
import { Input } from "./Input";
import { InputNumber } from "./InputNumber";
import { Select } from "./Select";
import { TextField } from "./TextField";
import { TextArea } from "./TextArea";
import { Carousel } from "./Carousel";
import { DateTimePicker } from "./DateTimePicker";
import { Radio } from "./Radio";
import {Password} from  "./Password"; 
export const Field = {
  AutoComplete,
  CheckBox,
  Input,
  InputNumber,
  Select,
  TextField,
  TextArea,
  Carousel,
  DateTimePicker,
  Radio,
  Password
};
